import Vue from 'vue'
// TODO : Не знаю кто и зачем придумал через переменную color определять ТИП сообщения,
//  но надо сделать нормально передавать group, title, type, text
export default {
  add(value, color, notifyGroup) {
    let contextualColor = ''
    switch (color) {
      case 'primary':
        contextualColor = 'success'
        break
      case 'info':
        contextualColor = 'info'
        break
      default:
        contextualColor = 'error'
    }

    const group = notifyGroup === undefined ? 'hasBottomNavigation' : notifyGroup
    Vue.notify({
      group: group,
      title: '',
      type: contextualColor,
      text: value,
    })
  },
}
